/**
 * URL hash slugs for event category sub-sections (same pattern as /production#service-id).
 */

function normalizeKey(s) {
  return s
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/** Nav menu labels that differ from subEvents.name in eventsData */
const MENU_LABEL_ALIASES = {
  Wedding: "Wedding Function",
};

/**
 * @param {string} name — subEvents.name
 * @returns {string} DOM id / URL hash (without #)
 */
export function subeventNameToSlug(name) {
  return name
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Match a navbar sub-item label to a subEvents entry and return its hash slug.
 * @param {string} menuLabel
 * @param {Array<{ name: string }> | undefined} subEvents
 * @returns {string | null}
 */
export function resolveSubeventSlug(menuLabel, subEvents) {
  if (!menuLabel || !subEvents?.length) return null;

  const searchLabel = MENU_LABEL_ALIASES[menuLabel] || menuLabel;
  const target = normalizeKey(searchLabel);

  let match = subEvents.find(
    (se) => normalizeKey(se.name) === target,
  );

  if (!match) {
    match = subEvents.find((se) => {
      const sn = normalizeKey(se.name);
      return sn === target || sn.includes(target) || target.includes(sn);
    });
  }

  if (!match) return null;
  return subeventNameToSlug(match.name);
}

/**
 * @param {string} menuLabel — subItems entry
 * @param {string} basePath — category.path
 * @param {Array<{ name: string }> | undefined} subEvents
 * @returns {string} react-router `to` path
 */
export function buildEventSubitemPath(menuLabel, basePath, subEvents) {
  const slug = resolveSubeventSlug(menuLabel, subEvents);
  return slug ? `${basePath}#${slug}` : basePath;
}
